<template src="./dashboard.html"></template>

<script>
import Navigation from 'Components/navigation/Navigation.vue';
import FooterBar from 'Components/footer/FooterBar.vue';
import BackToTop from 'Components/back_to_top/BackToTop.vue';
import SlideBar from 'Components/slidebar/Slidebar.vue';
import Logo from 'Components/logo/Logo.vue';


export default {
  components: {
    Navigation,
    FooterBar,
    BackToTop,
    SlideBar,
    Logo,
  },
};
</script>
